// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_rfwlI","foot_link":"index_foot_link_71n9L","list":"index_list_xeiPN","link":"index_link_ftPpg","copyright":"index_copyright_-4IUg"};